import { Injectable } from "@angular/core";
import { Subject, Observable, timer } from "rxjs";
import { tap, filter, mergeMap, switchMap, take, takeWhile, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class PollingService {
  private notifier = new Subject();

  poll<PollResultType>(
    startTime: number,
    intervalTime: number,
    pollFunction: () => Observable<PollResultType>
  ): Observable<PollResultType> {
    let isRequesting = false;
    return timer(startTime, intervalTime).pipe(
      filter(() => !isRequesting),
      tap(() => (isRequesting = true)),
      mergeMap(pollFunction),
      tap(() => (isRequesting = false)),
      takeUntil(this.notifier)
    );
  }

  pollUntill<T>(startTime: number, intervalTime: number, maxAttempts: number, responsePredicate: (res: T) => boolean) {
    return (source$: Observable<T>): Observable<T> =>
      timer(startTime, intervalTime).pipe(
        switchMap(() => source$),
        take(maxAttempts),
        takeWhile(response => responsePredicate(response)),
        takeUntil(this.notifier)
      );
  }

  stopPoll(): void {
    this.notifier.next(null);
  }
}
